<template>
  <div class="news">
    <div class="container-fluid vmc-py-big">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <h2 class="h1 vmc-text-primary vmc-heading">
              JAPAN VISA APPLICATION
            </h2>
            <p class="vmc-text-primary-2 letter-spacing-1 mb-0">
              By Veritas Admin — May 04, 2025
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center pt-4">
            <p class="my-3 text-left">
              Japan Embassy announced the opening of Japan Visa Application Centre (JVAC) to accept and issue visa applications. The Japan Visa Centre by VFS Service Philippines, Inc. is scheduled to begin its operation on 07 April 2025. Appointment is required for submission of documents through the website. Processing time is a minimum of 6 business days from the day the application is received.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewZealandElectronicTravelAuthority2025"
}
</script>

<style scoped>

</style>
